import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-426175ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tuto" }
const _hoisted_2 = {
  key: 0,
  class: "tuto-panel"
}
const _hoisted_3 = { class: "tuto-steps" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = {
  key: 0,
  class: "hint-down"
}
const _hoisted_6 = {
  key: 1,
  class: "hint-crouch"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "351",
  height: "76",
  viewBox: "0 0 351 76",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M350.5 54.408 330.028 75H.5V.5h350v53.908Z" })
], -1))
const _hoisted_8 = [
  _hoisted_7
]

import { computed, onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import gsap from 'gsap'
import { useGameState } from '@/services/composition'

import DesktopTutoStep from './DesktopTutoStep.vue';
import Viewport from '@/store/modules/Viewport';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const state = useGameState()

const { t } = useI18n()

const tutorialSteps = computed(() => {
  return [
    // {
    //   key: 'move_around',
    //   active: state.value.matches('tuto.xr.move_around') || state.value.matches('tuto.xr.crouch') || state.value.matches('tuto.xr.door') || state.value.matches('tuto.xr.actions') || state.value.matches('tuto.xr.exit_room'),
    //   validate: state.value.matches('tuto.xr.crouch') || state.value.matches('tuto.xr.door') || state.value.matches('tuto.xr.actions') || state.value.matches('tuto.xr.exit_room'),
    // },
    {
      key: 'crouch',
      active: state.value.matches('tuto.xr.crouch') || state.value.matches('tuto.xr.door') || state.value.matches('tuto.xr.actions') || state.value.matches('tuto.xr.exit_room'),
      validate: state.value.matches('tuto.xr.door') || state.value.matches('tuto.xr.actions') || state.value.matches('tuto.xr.exit_room'),
    },
    {
      key: 'door',
      active: state.value.matches('tuto.xr.door') || state.value.matches('tuto.xr.actions') || state.value.matches('tuto.xr.exit_room'),
      validate: state.value.matches('tuto.xr.actions') || state.value.matches('tuto.xr.exit_room'),
    },
    {
      key: 'actions',
      active: state.value.matches('tuto.xr.actions') || state.value.matches('tuto.xr.exit_room'),
      validate: state.value.matches('tuto.xr.exit_room'),
    },
  ]
});

const currentTutoID = computed(() => {
  if(state.value.matches('tuto.xr.exit_room')) {
    return 'move_around'
  } else if(state.value.matches('tuto.xr.crouch')) {
    return 'crouch'
  } else if(state.value.matches('tuto.xr.door')) {
    return 'door'
  } else if(state.value.matches('tuto.xr.actions')) {
    return 'actions'
  } else {
    return 'crouch'
  }
});

const showGuide = computed(() => {
  return currentTutoID.value === 'move_around' || (currentTutoID.value && state.value.context.hotspotHovered === -1)
})

const tutoGuideTitle = computed(() => {
  if(Viewport.isMobile && (currentTutoID.value === 'crouch' || currentTutoID.value === 'move_around')) {
    return t(`tuto.desktop.${currentTutoID.value}.guide_mobile`)
  }
  return t(`tuto.desktop.${currentTutoID.value}.guide`)
})

const onEnter = (el: HTMLElement, onComplete: gsap.Callback) => {
  const tl = gsap.timeline()
  tl.fromTo(el, { y: -300}, { y: 0, duration: 1, ease: 'quint.inOut' })
}

return (_ctx: any,_cache: any) => {
  const _component_ui_icon = _resolveComponent("ui-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, {
      css: false,
      onEnter: onEnter,
      appear: ""
    }, {
      default: _withCtx(() => [
        (_unref(currentTutoID))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tutorialSteps), (step) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: step.key,
                    class: _normalizeClass([[{ 'active': step.active, 'validate': step.validate }], "tuto-steps-item"])
                  }, [
                    _createVNode(_component_ui_icon, {
                      class: "icon",
                      name: "checkmark"
                    })
                  ], 2))
                }), 128))
              ]),
              (_openBlock(), _createBlock(DesktopTutoStep, {
                id: _unref(currentTutoID),
                key: _unref(currentTutoID)
              }, null, 8, ["id"]))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      name: "fade",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_unref(showGuide))
          ? (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["tuto-guide", [_unref(currentTutoID)]]),
              key: _unref(currentTutoID)
            }, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(tutoGuideTitle)), 1),
              (_unref(currentTutoID) === 'move_around')
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(_component_ui_icon, {
                      class: "icon",
                      name: "down"
                    }),
                    _createVNode(_component_ui_icon, {
                      class: "icon",
                      name: "down"
                    })
                  ]))
                : _createCommentVNode("", true),
              (_unref(currentTutoID) === 'crouch')
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
                : _createCommentVNode("", true)
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})